<template>
  <div>
    <div v-if="loading">
      <v-card outlined class="ma-4">
        <LoadingLine :title="'Tin nhắn đang được gửi đi'" :count="sendNoti.progress" />
      </v-card>
    </div>
    <v-card v-else outlined class="d-flex flex-column justify-center my-8 mx-16 pa-4">
      <p class="text--secondary">
        Đây là thao tác gửi tin nhắn tổng kết Học phí theo kỳ đóng cụ thể. Các thông tin về Học phí của học sinh trong
        kỳ đóng sẽ được tổng hợp và gửi tới ứng dụng Sổ liên lạc điện tử của phụ huynh học sinh.
      </p>
      <p class="text--secondary">
        Nếu đã chắc chắn, bạn có thể tích vào ô <span class="font-weight-bold">[Xác nhận gửi tin]</span> bên dưới, sau
        đó nhấn nút <span class="font-weight-bold">[Gửi]</span>.
      </p>

      <v-checkbox v-model="checkbox" label="Xác nhận gửi tin" />
      <v-form v-show="checkbox" ref="form">
        <v-row class="">
          <v-col class="text--secondary mt-2 pb-0" cols="12" md="4"> Kỳ đóng <span class="error--text">*</span> </v-col>
          <v-col class="pb-0" cols="12" md="5">
            <AutocompleteTuitionPeriod
              :rules="[$rules.required]"
              v-model="tuitionPeriod"
              label="Kỳ đóng"
              placeholder="Kỳ đóng"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text--secondary mt-2" cols="12" md="4">
            Hạn đóng tương ứng <span class="error--text">*</span>
          </v-col>
          <v-col class="" cols="12" md="5">
            <DateIOSPicker label="Hạn đóng" :date.sync="deadline" outlined :rules="[$rules.date]" dense />
          </v-col>
        </v-row>
        <v-row class="d-flex justify-end">
          <v-col class="d-flex justify-end mt-2 pb-0">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="btn-custom">
                  T<span class="btn-custom-lowercase">ùy chỉnh nhóm đối tượng nhận tin</span>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item class="list-item-title">
                  <v-list-item-title style="cursor: pointer" @click="openDialog('student')"
                    >Tìm kiếm và chọn học sinh</v-list-item-title
                  >
                </v-list-item>
                <v-list-item class="list-item-title">
                  <v-list-item-title style="cursor: pointer" @click="openDialog('normal')"
                    >Chọn nhóm đối tượng chịu phí</v-list-item-title
                  >
                </v-list-item>
                <v-list-item class="list-item-title">
                  <v-list-item-title style="cursor: pointer" @click="openDialog('priority')"
                    >Chọn nhóm đối tượng giảm trừ</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class=" d-flex justify-end mb-1">
          <v-col class="d-flex justify-end">
            <span v-if="typeDialog === 'student'" class="d-flex justify-end grey--text">
              (Đã chọn {{ selectedStudent.length }} học sinh)</span
            >
            <span
              v-else-if="typeDialog === 'normal' || ('priority' && groupChoice && groupChoice.title)"
              class="disabled--text"
            >
              (Đã chọn nhóm {{ groupChoice.type == 'normal' ? 'chịu phí' : 'giảm trừ' }}
              <strong>{{ groupChoice.title }}</strong
              >)
            </span>
            <span v-else></span> </v-col
        ></v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!checkbox"
          @click="sendTuitionFeeNoti"
          depressed
          color="primary"
          class="px-6 mt-4  white--text"
          >Gửi</v-btn
        >
      </v-card-actions>
      <PostTuitionFeeDialog ref="postTuitionFeeDialog" :type="typeDialog" @choice-group="choiceGroup">
      </PostTuitionFeeDialog>
      <SelectStudentDialog ref="selectedStudents" @choice-student="choiceGroup" />
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapState } from 'vuex'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import AutocompleteTuitionPeriod from '@/components/basic/input/AutocompleteTuitionPeriod.vue'
import PostTuitionFeeDialog from './PostTuitionFeeDialog.vue'
import SelectStudentDialog from '@/modules/tuitionFee/detail-group/dialogAddStudent/AddStudentDialog.vue'
import LoadingLine from '@/components/basic/LoadingLine.vue'
import { get } from 'lodash'
export default {
  components: {
    AutocompleteTuitionPeriod,
    DateIOSPicker,
    PostTuitionFeeDialog,
    LoadingLine,
    SelectStudentDialog
  },
  data() {
    return {
      // items:[''],
      checkbox: false,
      tuitionPeriod: null,
      deadline: '',
      typeDialog: '',
      loading: false,
      interval: '',
      sendNoti: {},
      groupChoice: {}
    }
  },
  async created() {
    this.date = moment().toISOString()
    let sendNoti = await this.getProgressTuitionFeePeriod({ status: 'running' })
    if (sendNoti.length > 0) {
      this.sendNoti = sendNoti[0]
      this.loading = true
      this.getProgress()
    }
  },
  computed: {
    ...mapState('PostCreateAuto', ['sendNotiTuitionFee']),
    ...mapGetters('auth', ['profile']),
    ...mapGetters('tuitionFeeGroupStudent', ['selectedStudent'])
  },
  methods: {
    ...mapActions('PostCreateAuto', ['sendTuitionFeePeriod', 'getProgressTuitionFeePeriod']),
    getProgress() {
      this.interval = setInterval(async () => {
        if (this.sendNoti.status === 'running') {
          let newProgress = await this.getProgressTuitionFeePeriod({ id: this.sendNoti.id })
          if (newProgress[0].status === 'finished') {
            newProgress[0].progress = 99.9
          }
          this.sendNoti = newProgress[0]
        } else if (this.sendNoti.status === 'finished') {
          this.$alert.success('Đã gửi tin nhắn Học phí, vui lòng xem chi tiết trong lịch sử gửi tin')
          this.loading = false
          clearInterval(this.interval)
        }
      }, 2000)
    },
    openDialog(type) {
      this.typeDialog = type
      if (type === 'student') {
        this.$refs.selectedStudents.openDialog('sms')
      } else {
        this.$refs.postTuitionFeeDialog.openDialog()
      }
    },
    choiceGroup(value) {
      this.groupChoice = value
    },
    convertStudent(students) {
      let newArray = []
      students.forEach(student => {
        newArray.push(get(student, 'id'))
      })
      return newArray
    },
    async sendTuitionFeeNoti() {
      if (!this.$refs.form.validate()) return
      try {
        let metadata = { students: [] }
        if (this.typeDialog === 'student') metadata.students = this.convertStudent(this.selectedStudent)
        this.loading = true
        let params = {
          status: 'running',
          tuition_fee_period: this.tuitionPeriod.id,
          staff: this.profile.id,
          deadline: moment(this.deadline).format('DD/MM/YYYY')
        }
        if (this.typeDialog === 'student') {
          params = { ...params, type: 'all', metadata: metadata }
        } else {
          const selectType =
            this.typeDialog === 'normal' ? 'normalGroup' : this.typeDialog === 'priority' ? 'priorityGroup' : 'all'
          params = {
            ...params,
            type: selectType,
            groupId: this.groupChoice.id
          }
        }
        let sendNoti = await this.sendTuitionFeePeriod(params)
        this.sendNoti = sendNoti
        this.getProgress()
      } catch (error) {
        this.$alert.error(`Đã xảy ra lỗi trong quá trình gửi tin nhắn! Lỗi: ${error}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item .v-list-item__title {
  font-size: 14px;
}

.btn-custom {
  margin: 0 -15px;
  background-color: white !important;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 16px;
  color: #0d47a1 !important;
}

.btn-custom .btn-custom-lowercase {
  text-transform: lowercase;
  color: #0d47a1 !important;
  margin-left: -3px;
}
.btn-custom .btn-custom-lowercase:hover {
  color: aqua;
}
.custom.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

.custom.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}

.v-list-item__title {
  display: flex;
  justify-content: flex-end;
}

.list-item-title:hover {
  background-color: #ededed;
}
</style>
